
let store = {};

export const UserStore = {
    get: (name, defaultValue = {}) => {
        let obj = store[name];
        if (obj) {
            return obj;
        }
        store[name] = defaultValue;
        return defaultValue;
    },
    put: (name, obj) => {
        store[name] = obj;
    },
    remove: (name) => {
        delete store[name];
    },
    reset: () => {
        store = {};
    }
};
